import React from 'react';
import { connect } from 'react-redux';
import { datasetUrl } from '@/constants/urls';
import datasetStatus from '@/datasets/status/helper';
import { newCohortFromDataset } from '@/cohorts/actions';
import { showDatasetConditions } from '@/datasets/conditions/actions';
import DatasetCardItemWrapper from '@/datasets/components/DatasetCardItemWrapper';
import CollectionDatasetTools from './CollectionDatasetTools';

const CollectionDatasetCardItem = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  category,
  code,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  dataset,
  hasConditions,
  newCohort,
  newCohortCode,
  newRequestCode,
  onCheckBoxClick,
  showConditions,
  single,
  upward,
}) => (
  <DatasetCardItemWrapper
    accessRequestAllowed={accessRequestAllowed}
    accessRequestSupported={accessRequestSupported}
    accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
    cohortAllowed={cohortAllowed}
    cohortSupported={cohortSupported}
    cohortUnsupportedReasons={cohortUnsupportedReasons}
    dataset={dataset}
    hasConditions={hasConditions}
    newCohort={newCohort}
    newCohortCode={newCohortCode}
    newRequestCode={newRequestCode}
    onCheckBoxClick={onCheckBoxClick}
    showConditions={showConditions}
    showStatus
    single={single}
  >
    <CollectionDatasetTools
      iconSize="large"
      url={datasetUrl(dataset, '#')}
      upward={upward}
      category={category}
      code={code}
      dataset={dataset}
      listItem
    />
  </DatasetCardItemWrapper>
);

const mapStateToProps = ({
  auth: { role },
  cohorts: { newCohortCode },
  requests: { newRequestCode },
}, { dataset }) => ({
  newCohortCode,
  newRequestCode,
  ...datasetStatus(role, dataset, dataset.primary_dictionary),
});

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetCardItem);
